import React, { useState, useEffect, useCallback, useMemo } from "react";
import { Col, Row } from "react-bootstrap";
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import GYAxios from "../../../util/GYAxios";
import { DatePicker, Modal, Select } from 'antd';
import moment from 'moment';
import { useUser } from "../../../util/user";
import './IssueCalendar.css';

const { RangePicker } = DatePicker;

const IssueCalendar = (props) => {

	const user = useUser();

	const initialDateRange = [ moment().subtract(1, 'month').startOf('month'), moment() ];
	const [dateRange, setDateRange] = useState(initialDateRange);

	const issueTypes = { ALL: {value: 'all', label: 'All Issues'}, UNSOLVED: {value:'unsolved', label: 'Unsolved Issues'} };
	const [issueType, setIssueType] = useState(issueTypes.ALL);

	const unavailabilityOptions = useMemo(() => [
		{ value: 'GA', label: 'GA' },
		{ value: 'CA', label: 'CA' },
		{ value: 'TA', label: 'TA' },
		{ value: 'TPA', label: 'TPA' },
		{ value: 'N/A', label: 'N/A' }
	], []);
	const [selectedUnavailabilities, setSelectedUnavailabilities] = useState([]);

	const getDisplayCountries = useCallback(roles => {
			const displayCountries = [];
			if (roles.find(role => role === '_GY:TH')) { displayCountries.push('TH') }
			if (roles.find(role => role === '_GY:VN')) { displayCountries.push('VN') }
			if (roles.find(role => role === '_GY:KH')) { displayCountries.push('KH') }
			return displayCountries
		}, []);
	const countrySelect = { TH: {value: 'th', label: 'Thailand'}, VN: {value: 'vn', label: 'Vietnam'}, KH: {value: 'kh', label: 'Cambodia'}, PH: {value: 'ph', label: 'Philippines'} };
	const [selectedCountry, setSelectedCountry] = useState(countrySelect[getDisplayCountries(user.roles)[0]]?.value || countrySelect.TH.value);

	const [issues, setIssues] = useState([]);
	const issuesFilterd = useMemo(() => issues.filter(issue => selectedUnavailabilities.includes(issue.unavailability)), [issues, selectedUnavailabilities]);

	useEffect(() => {
		GYAxios.get(`/issue/opt/${issueType.value}?country=${selectedCountry}&start=${dateRange[0].format("YYYY-MM-DD")}&end=${dateRange[1].format("YYYY-MM-DD")}`)
			.then(res => {
				console.log(res.data);
				setIssues(res.data);
			});
	}, [ dateRange, selectedCountry, issueType ]);

	const showIssueDetails = issue => {
		Modal.info({
			title: issue.gy_issue,
			content: <div>
				<p>Site Name: {issue.site_name}</p>
				<p>Company: {issue.company}</p>
				<p>Alarm: {issue.alarm}</p>
				<p>Problem: {issue.problem}</p>
				<p>Unavailability: {issue.unavailability}</p>
				<p>Issue Status: {issue.status ? 'Solved' : 'Unsolved'}</p>
				<p>Issue Date: {moment(issue.issue_date).format('YYYY-MM-DD HH:mm')}</p>
				<p>Resolved Date: {issue.resolved_date ? moment(issue.resolved_date).format('YYYY-MM-DD HH:mm') : 'N/A'}</p>
			</div>,
		})
	};

	const handleEventClick = (info) => {
    showIssueDetails(info.event.extendedProps);
  };

  const eventContent = (e) => {
		console.log('rendering event', e);
    return (
      <div style={{ cursor: 'pointer', backgroundColor: '#88b917', color: 'white', display: 'inline-block', padding: '0 0.5em', borderRadius: '0.4em', maxWidth: '100%' }}>
        <b style={{ display: 'block', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}>
					{moment(e.event.extendedProps.issue_date).format('HH:mm')} {e.event.extendedProps.gy_issue}
				</b>
        <div style={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}>
					{e.event.extendedProps.site_name} {e.event.extendedProps.company}
				</div>
      </div>
    );
  };

	return (
		<div className="perf-table panel panel-default">
			<h3 style={{ padding: '1em', fontSize: '2em' }}>Issues Calendar</h3>
			<div style={{ padding: '1em' }}>
					<RangePicker value={dateRange} onChange={([dateRangeStart, dateRangeEnd]) => {if(dateRangeStart && dateRangeEnd) { console.log({dateRangeStart, dateRangeEnd}); setDateRange([ dateRangeStart, dateRangeEnd ])}}} />
					<Select
						mode="multiple"
						style={{ width: '300px' }}
						placeholder="Unavailability Select"
						defaultValue={selectedUnavailabilities}
						value={selectedUnavailabilities}
						onChange={options => setSelectedUnavailabilities(options)}
						options={unavailabilityOptions}
					/>
					<Select
						style={{ width: '200px' }}
						placeholder="Country"
						value={selectedCountry}
						onChange={option => setSelectedCountry(option)}
						options={Object.values(countrySelect)}
					/>
			</div>
			<div style={{ padding: '1em' }}>
				<FullCalendar
					plugins={[ dayGridPlugin ]}
					initialView="dayGridMonth"
					events={issuesFilterd.map(issue => ({ ...issue, title: issue.gy_issue, start: issue.issue_date, end: issue.resolved_date || issue.issue_date }))}
					eventClick={handleEventClick}
					eventContent={eventContent}
					headerToolbar={{
						left: 'prev,next',
						center: 'title',
						right: 'dayGridMonth,dayGridWeek,dayGridDay'
					}}
				/>
			</div>
		</div>
	);
};

export default IssueCalendar;
